import { defineMessages } from 'react-intl';

export default defineMessages({
  noOptions: {
    id: 'search.bar.search.input.noOptions',
    defaultMessage: 'Aucun résultat',
  },
});
